<template>
    <div class="modal fade" id="commercial_invoice_modal" tabindex="-1" role="dialog" aria-labelledby="commercial_invoice_modal_label" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> {{ $helper.trans('Completing_commercial_invoice') }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-for="(shipment, index) in filteredMassShipments" :key="index" >
                        <div 
                            class="row justify-content-center commercialInvoiceModal commercialInvoiceBlock" 
                            :class="'commercialInvoiceBlock_' + index" 
                            style="display:none;"
                        >
                            <div class="col-12 mt-4 input-grid">
                                <label :for="'op-29'+index" class="custom-checkbox-wrap" @click="$forceUpdate();">
                                    {{ $helper.trans('Buyer_and_shipping_addresses_match') }}
                                    <input 
                                        type="checkbox" 
                                        :id="'op-29'+index"
                                        v-model="shipment.commercialInvoiceModal.sameInvoiceAddress" 
                                        :value="1"
                                    >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-12 input-grid mt-3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.companyOrSender" :placeholder="'* '+$helper.trans('Company_or_firstname_lastname')" class="input-big w-100 commercialInvoiceModal_differentAddress_companyOrSender_input" />
                            </div>
                            <div class="col-12 input-grid mt-3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.contactPerson" :placeholder="'* '+$helper.trans('Contact_person')" class="input-big w-100 commercialInvoiceModal_differentAddress_contactPerson_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 phone" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.phone" :placeholder="'* '+$helper.trans('Phone_number')" class="input-big w-100 commercialInvoiceModal_differentAddress_phone_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 email" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.email" :placeholder="'* '+$helper.trans('Contact_email')" class="input-big w-100 commercialInvoiceModal_differentAddress_email_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 city" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.city" :placeholder="'* '+$helper.trans('City')" class="input-big w-100 commercialInvoiceModal_differentAddress_city_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 address1" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.address1" :placeholder="'* '+$helper.trans('Address')+' 1'" class="input-big w-100 commercialInvoiceModal_differentAddress_address1_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 address2" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.address2" :placeholder="$helper.trans('Address')+' 2'" class="input-big w-100 commercialInvoiceModal_differentAddress_address2_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 address3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.address3" :placeholder="$helper.trans('Address')+' 3'" class="input-big w-100 commercialInvoiceModal_differentAddress_address3_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 countryCode" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <select2-component
                                    :values="countries"
                                    :placeholder="'* '+$helper.trans('Country')"
                                    :noLang="true"
                                    :notKeyed="true"
                                    classes="input-big commercialInvoiceModal_differentAddress_countryCode_input"
                                    v-model="shipment.commercialInvoiceModal.differentAddress.countryCode"
                                ></select2-component>    
                            </div>
                            <div class="col-12 input-grid mt-3 postCode" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <input type="text" v-model="shipment.commercialInvoiceModal.differentAddress.postCode" :placeholder="'* '+$helper.trans('Zip_code')" class="input-big w-100 commercialInvoiceModal_differentAddress_postCode_input" />
                            </div>
                            <div class="col-12 input-grid mt-3 stateOrProvince" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress && shipment.commercialInvoiceModal.differentAddress.countryCode && shipment.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'us'">
                                <select2-component
                                    :values="$store.state.$siteSettings['State_list']"
                                    :placeholder="'* '+$helper.trans('State')"
                                    classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                    v-model="shipment.commercialInvoiceModal.differentAddress.stateOrProvince"
                                ></select2-component>
                            </div>
                            <div class="col-12 input-grid mt-3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress && shipment.commercialInvoiceModal.differentAddress.countryCode && shipment.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'ca'">
                                <select2-component
                                :values="$store.state.$siteSettings['Province_list']"
                                    :placeholder="'* '+$helper.trans('Province')"
                                    classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                    v-model="shipment.commercialInvoiceModal.differentAddress.stateOrProvince"
                                ></select2-component>
                            </div>
                            <div class="col-12 input-grid mt-3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress && shipment.commercialInvoiceModal.differentAddress.countryCode && shipment.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'ie'">
                                <select2-component
                                    :values="$store.state.$siteSettings['Counties_list']"
                                    :placeholder="'* '+$helper.trans('County')"
                                    classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                    v-model="shipment.commercialInvoiceModal.differentAddress.stateOrProvince"
                                ></select2-component>
                            </div>
                            <div class="col-12 input-grid mt-3 stateOrProvince" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress && shipment.commercialInvoiceModal.differentAddress.countryCode && shipment.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'au'">
                                <select2-component
                                    :values="$store.state.$siteSettings['AU_state_list']"
                                    :placeholder="'* '+$helper.trans('State')"
                                    classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                    v-model="shipment.commercialInvoiceModal.differentAddress.stateOrProvince"
                                />
                            </div>
                            <div class="col-12 input-grid mt-3" v-show="!shipment.commercialInvoiceModal.sameInvoiceAddress">
                                <div class="border-solid"></div>
                            </div>

                            <div class="col-12 input-grid">
                                <div class="mt-3 position-relative">
                                    <select2-component
                                        :values="deliveryConditionsValues"
                                        :placeholder="$helper.trans('Delivery_conditions')+' *'"
                                        :noLang="true"
                                        :lowerCaseIndices="false"
                                        classes="vue-select2 commercialInvoiceModal_commercialInvoiceCondition_input"
                                        v-model="shipment.commercialInvoiceModal.commercialInvoiceCondition"
                                    ></select2-component>

                                    <i class="fa fa-question-circle info-question-circle position-absolute" style="top: 0; right: -15px;">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="exportInfoCloud"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="mt-3">
                                    <select2-component
                                        :values="$store.state.$siteSettings['Export_reasons_admin'].split(',')"
                                        :placeholder="$helper.trans('Reason_for_export')+' *'"
                                        :noLang="true"
                                        :lowerCaseIndices="false"
                                        classes="vue-select2 commercialInvoiceModal_commercialInvoiceExportReason_input"
                                        v-model="shipment.commercialInvoiceModal.commercialInvoiceExportReason"
                                    ></select2-component>
                                </div>
                                <div class="mt-3">
                                    <select2-component
                                        :values="currencies"
                                        :placeholder="$helper.trans('Currency')+' *'"
                                        :noLang="true"
                                        :lowerCaseIndices="false"
                                        classes="vue-select2 commercialInvoiceModal_commercialInvoiceCurrency_input"
                                        v-model="shipment.commercialInvoiceModal.commercialInvoiceCurrency"
                                    ></select2-component>
                                </div>
                                <div class="mt-3">
                                    <input type="text" v-model="shipment.commercialInvoiceModal.receiverTaxNumber" :placeholder="$helper.trans('Recipient_taxpayer_number')" class="input-big w-100 commercialInvoiceModal_receiverTaxNumber_input" />
                                </div>

                                <div class="border-solid"></div>
                            </div>
                            <div class="col-12 input-grid declaration">
                                <span class="title-text">
                                    {{ $helper.trans('Declaration_info') }} *
                                </span>
                                <textarea class="w-100 commercialInvoiceModal_declaration_input" v-model="shipment.commercialInvoiceModal.declaration" cols="10" rows="8"></textarea>
                            </div>
                            <div class="col-12 input-grid">
                                <div class="mt-4">
                                    <span class="title-text">
                                        {{ $helper.trans('Additional_comments') }}
                                    </span>
                                    <textarea class="w-100 commercialInvoiceModal_description_input" v-model="shipment.commercialInvoiceModal.description" cols="10" rows="3"></textarea>
                                </div>

                                <div class="border-solid"></div>

                                <span class="warning">
                                    {{ $helper.trans('Information_about_shipped_goods') }}
                                </span>
                            </div>
                            <div class="col-12 input-grid products" v-for="(product, productIndex) in shipment.commercialInvoiceModal.products" :key="productIndex">
                                <div :class="`mt-4 description${productIndex}`">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="title-text">                                        
                                            {{ $helper.trans('Item_description') }} *
                                        </span>
                                        <i v-show="productIndex !== 0" @click="removeProduct(shipment, productIndex);" class="fa fa-times" style="color: red; cursor: pointer;"></i>
                                    </div>
                                    <textarea 
                                        v-model="shipment.commercialInvoiceModal.products[productIndex].description" 
                                        class="w-100" 
                                        :class="`commercialInvoiceModal_products_${productIndex}_description_input`" 
                                        cols="10" 
                                        rows="3"
                                    ></textarea>
                                </div>
                                <div :class="`mt-3 tariffCode${productIndex}`">
                                    <input type="text" 
                                        v-model="shipment.commercialInvoiceModal.products[productIndex].tariffCode" 
                                        :placeholder="$helper.trans('Tariff_code') + (shipment.Country === 'gb' && shipment.ServiceCode === '11' ? ' *' : '')" 
                                        class="input-big w-100"
                                        :classes="`only_parent_alert`"
                                        :class="`massShipments_${index}_commercialInvoiceModal_products_${productIndex}_tariffCode_input`" 
                                    />
                                    <i class="fa fa-question-circle info-question-circle position-absolute">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Tariff_code_info')"></div>
                                        </div>
                                    </i>
                                    <span 
                                        class="warning d-block"
                                        style="font-size: 13px;"
                                        v-if="shipment.Country === 'gb' && shipment.ServiceCode === '11'" v-html="$helper.trans('Hs_code')"></span>
                                </div>
                                <div :class="`mt-3 position-relative countryOfOrigin${productIndex}`">               
                                    <select2-component
                                        :values="countries"
                                        :placeholder="$helper.trans('Origin_country')+' *'"
                                        :noLang="true"
                                        :notKeyed="true"
                                        :classes="`commercialInvoiceModal_products_${productIndex}_countryOfOrigin_input`"
                                        dropDownClass="select2_customization"
                                        dropDownParent="#commercial_invoice_modal .modal-body"
                                        v-model="shipment.commercialInvoiceModal.products[productIndex].countryOfOrigin"
                                    ></select2-component>    
                                    <i class="fa fa-question-circle info-question-circle position-absolute" style="top: 0; right: -15px;">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Origin_country_info')"></div>
                                        </div>
                                    </i>                         
                                </div>
                                <div :class="`mt-3 count${productIndex}`">
                                    <input type="text" 
                                        v-model="shipment.commercialInvoiceModal.products[productIndex].count" 
                                        :placeholder="$helper.trans('Number_of_units')+' *'" 
                                        class="input-big w-100" 
                                        :class="`commercialInvoiceModal_products_${productIndex}_count_input`" 
                                    />
                                </div>
                                <div :class="`mt-3 unitPrice${productIndex}`">
                                    <input type="text" 
                                        v-model="shipment.commercialInvoiceModal.products[productIndex].unitPrice" 
                                        :placeholder="$helper.trans('Unit_price')+' *'" 
                                        class="input-big w-100" 
                                        :class="`commercialInvoiceModal_products_${productIndex}_unitPrice_input`" 
                                    />
                                </div>
                            </div>
                            <div class="col-12 input-grid">
                                <div class="add-another-product text-center mt-4" @click="addProduct(shipment);">
                                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                    <p>{{ $helper.trans('Add_another_product') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer-custom">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 input-grid">
                            <button type="button" @click="saveModal();" class="btn btn-primary">{{ $helper.trans('Submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            countries: {},
        };
    },
    created: function(){
        let vueThis = this;
        
        vueThis.countries = {};
        $.each(vueThis.$store.state.countriesList, function(index, element){         
            vueThis.countries[index] = {
                'key': element.country_code.toLowerCase(),
                'text': element.title,
            };
        }); 
    },
    methods: {
        addProduct: function(shipment){
            shipment.commercialInvoiceModal.products.push({
                description: '',
                tariffCode: '',
                countryOfOrigin: '',
                count: '',
                unitPrice: '',
            });
        },
        removeProduct: function(shipment, index){
            shipment.commercialInvoiceModal.products.splice(index, 1);
        },
        saveModal: async function(){  
            $('#commercial_invoice_modal').modal('hide');            
        },
    },
    computed:{
        filteredMassShipments() {
            let vueThis = this;
            let northernIrelandRegex = /^BT/i;

            let massShipments = {};
            $.each(vueThis.$store.state.massShipments, function (index, element) {
                let add = false;
                if (element.Country === 'gb' && northernIrelandRegex.test(element.PostCode)) {
                    add = true;               
                }
        
                if (element.Country === 'mc') {
                    add = true;                 
                }
        
                if (!vueThis.$helper.checkNotEu(element.Country)) {
                    add = true;                   
                }

                if (add) {
                    massShipments[index] = element;
                }
            });       
        
            return massShipments;
        },
        deliveryConditionsValues() {    
            if(this.$store.state.$siteSettings['Logged_in']){
                return this.$store.state.$siteSettings['Delivery_conditions_admin'].split(',');
            }

            return this.$store.state.$siteSettings['Delivery_conditions_offline_admin'].split(',');
        },
        exportInfoCloud() {         

            if(this.$store.state.$siteSettings['Logged_in'] && this.$store.state.$siteSettings['customer_payment_type'] === 'all'){
                return this.$helper.trans('Delivery_conditions_info_logged_in_all');
            }

            return this.$helper.trans('Delivery_conditions_info_logged_in');
        },    
        currencies() {
            let options = {};
            let splitCurrencies = this.$store.state.$siteSettings['Commercial_invoice_currencies'].split(',');
            $.each(splitCurrencies, function(index, element){
                options[element.trim()] = element.trim();
            });

            return options;
        },
    }
}
</script>
